import React from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Divider, Typography, useTheme } from "@mui/material";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left";
import { blueGrey, grey } from "@mui/material/colors";
import KeyShieldSVG from "../../../../media/images/icons/key-shield";
import InfoTriangle from "../../../../media/images/icons/info-triangle";
import CustomPasswordInput from "../../../components/CustomPasswordInput";
import CustomButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import { useAppDispatch } from "../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../redux/features/dialogSlice";
export default function ChangePasswordPage() {
  const theme = useTheme();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const changePassFormik = useFormik({
    initialValues: {
      newPassword: "",
      password: "",
      repeatPass: "",
    },
    validationSchema: yup.object().shape({
      password: yup.string().required("این فیلد الزامی است!"),
      newPassword: yup.string().required("این فیلد الزامی است!"),
      repeatPass: yup
        .string()
        .oneOf(
          [yup.ref("newPassword"), undefined],
          "رمز عبور باید با تکرار رمز عبور مطابقت داشته باشد!"
        )
        .required("این فیلد الزامی است!"),
    }),
    validateOnChange: true,
    onSubmit: (values) => {
      const { repeatPass, ...res } = values;
      postNewPassword(res);
    },
  });

  const { trigger: postNewPassword, isMutating: isPostNewPasswordMutating } =
    useSWRMutation(
      [`/User/ChangePassword`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          changePassFormik.resetForm();
          dispatch(setOpenDialog(true));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle("رمز عبور شما با موفقیت تغییر کرد!"));
          // dispatch(setDialogDescription(""));

          setTimeout(() => {
            dispatch(setOpenDialog(false));
          }, 3000);
        },
      }
    );

  return (
    <>
      <MobileHeader title={HeadTitle()} hasScroll={false} />
      <style>
        {`
            .MuiDivider-root {
            margin:0;
            }
            `}
      </style>
      <Box
        sx={{
          flex: 1,
          paddingX: "8px",
        }}
      >
        <Box
          sx={{
            border: "1px solid",
            borderColor: blueGrey[100],
            backgroundColor: "bgColor.white",
            padding: "16px",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
            }}
          >
            <KeyShieldSVG color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
              }}
            >
              تغییر رمز عبور
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              backgroundColor: theme.palette.primary[50],
              padding: "10px 12px",
              borderRadius: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <InfoTriangle color={theme.palette.primary.main} />

              <Typography
                sx={{
                  fontSize: "16px",
                  color: "primary.main",
                }}
              >
                توجه:
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "14px",
              }}
            >
              در صورت فراموشی رمز عبور فعلی، از حساب خود خارج شوید و از طریق
              فراموشی رمز ، رمز خود را تغییر دهید.
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              marginTop: "8px",

              flexDirection: "column",
              gap: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                رمز عبور فعلی
              </Typography>
              <CustomPasswordInput
                placHolder="رمز عبور فعلی را وارد کنید"
                name="password"
                handelChange={changePassFormik.handleChange}
                value={changePassFormik.values.password}
                error={
                  changePassFormik.touched.password &&
                  Boolean(changePassFormik.errors.password)
                }
                errorMessage={
                  changePassFormik.touched.password &&
                  changePassFormik.errors.password
                }
              />
            </Box>
            <Divider variant="middle" />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                رمز عبور جدید{" "}
              </Typography>
              <CustomPasswordInput
                placHolder="رمز عبور جدید را وارد کنید"
                name="newPassword"
                handelChange={changePassFormik.handleChange}
                value={changePassFormik.values.newPassword}
                error={
                  changePassFormik.touched.newPassword &&
                  Boolean(changePassFormik.errors.newPassword)
                }
                errorMessage={
                  changePassFormik.touched.newPassword &&
                  changePassFormik.errors.newPassword
                }
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                تکرار رمز عبور جدید{" "}
              </Typography>
              <CustomPasswordInput
                placHolder="رمز عبور جدید را دوباره وارد کنید"
                name="repeatPass"
                handelChange={changePassFormik.handleChange}
                value={changePassFormik.values.repeatPass}
                error={
                  changePassFormik.touched.repeatPass &&
                  Boolean(changePassFormik.errors.repeatPass)
                }
                errorMessage={
                  changePassFormik.touched.repeatPass &&
                  changePassFormik.errors.repeatPass
                }
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CustomButton
                flex={1}
                justifyContent="center"
                onClick={() => navigate(-1)}
                bgColor={theme.palette.primary[50]}
                title={"انصراف"}
                fSize="16px"
                fWeight="700"
                borderColor={theme.palette.primary.main}
                py="10px"
                px="6px"
                gap="4px"
                borderRadius="6px"
                textColor={theme.palette.primary.main}
              />
              <CustomButton
                flex={1}
                loading={isPostNewPasswordMutating}
                justifyContent="center"
                onClick={changePassFormik.handleSubmit}
                bgColor={"primary.main"}
                title={"ذخیره رمز عبور جدید"}
                fSize="16px"
                fWeight="700"
                py="10px"
                px="6px"
                gap="4px"
                borderRadius="6px"
                textColor={"#fff"}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

function HeadTitle() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        onClick={() => navigate("../profile")}
        sx={{
          color: "secondary.main",
          fontWeight: 600,
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        حساب کاربری من
      </Typography>
      <ArrowTickLeft size={16} color={grey[800]} />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        ویرایش اطلاعات{" "}
      </Typography>
    </Box>
  );
}
